import { http } from "@/shared/api/http";

export interface WorkspaceScan {
  id: string; url: string; host: string; industry_label: string; overall_score: number;
  scores: Record<string, number>; executive_summary: string; quick_wins: string[];
  created_at: string; delta: { previous_scan_id: string | null; overall_score_change: number | null; score_changes: Record<string, number> };
  proposal: {
    status: "pending" | "approved" | "rejected";
    changes: Array<{ brain: "business_brain" | "brand_brain"; question_id: string; label: string; before: unknown; after: unknown }>;
  };
}

export const listWorkspaceScans = (workspaceId: string) =>
  http<WorkspaceScan[]>(`/workspaces/${workspaceId}/business-discovery/scans`);
export const runWorkspaceScan = (workspaceId: string, url: string) =>
  http<WorkspaceScan>(`/workspaces/${workspaceId}/business-discovery/scans`, { method: "POST", body: { url } });
export const decideWorkspaceScan = (workspaceId: string, scanId: string, decision: "approve" | "reject") =>
  http<WorkspaceScan>(`/workspaces/${workspaceId}/business-discovery/scans/${scanId}/${decision}`, { method: "POST" });
